export default __webpack_public_path__ + "static/banner2-7d8b06b7ac27887ad6db77b32b84e776.png";